import React, { useState } from "react";
import { useNavigate } from "react-router-dom";

// icons
import { FaCheck } from "react-icons/fa";

// components
import CommonModal from "../../../components/modal/CommonModal";

// utils
import { validateConfirmPW, validatePW } from "../../../utils/validation";

// api
import { changePWWithOrigin } from "../../../services/apis/auth";


function MomtheraMyPageModifyPW() {
    const navigate = useNavigate();
    const [password, setPassword] = useState({ prev: "", new: "", confirm: "" });
    const [isNonValidPW, setIsNonValidPW] = useState(false);

    const [showModifyModal, setShowModifyModal] = useState(false);

    function goToMyPageMain() {
        navigate("/dtx006/mypage");
    }

    const handleSubmit = async () => {
        if(Object.values(password).some(e=>e==="")) {
            return;
        }

        if(validatePW(password.new, password.prev)!=="valid" || validateConfirmPW(password.new, password.confirm)!=="valid"){
            return;
        }

       try {
            // const tokenInfo = JSON.parse(localStorage.getItem('dtx006token'));
            const username = localStorage.getItem('saveId');
            const request = {
                username,
                originPassword: password.prev,
                newPassword: password.new
            }
            const res = await changePWWithOrigin(request);
            if(parseInt(res.status/200, 10)===1){
                setIsNonValidPW(false);
                setShowModifyModal(true);
            }else if(res.response && res.response.data && res.response.data.code==="Need-a-different-password"){
                alert(res.response.data.message)
            }else {
                setIsNonValidPW(true);
            }
       }catch(err){
            setIsNonValidPW(true);
       }
    }

    const closeModifyModal = () => {
        setShowModifyModal(false);
        navigate('/dtx006/mypage');
    }

    const ModifyModalBody = (
        <div className="mypage_modal_body">비밀번호가 변경되었습니다.</div>
    )

    const ModifyModalFooter = (
        <div className="mypage_modal_footer">
            <button className="submit complete" type="button" onClick={closeModifyModal}>확인</button>
        </div>
    )

    return (
        <div className="dashboardContent dtx006">
			<div className="dashboardContent__title">
				<span className="dashboardContent__title__content">마이페이지</span>
			</div>
            <div className="mypage_center_box_wrapper">
                <div className="title_wrapper">
                    <div className="title">비밀번호 변경</div>
                    <div className="description">- 영문, 숫자, 특수기호 중 3개 이상 조합으로 8~20자 입력해주세요.<br/>- 아이디, 전화번호 등 개인정보와 관련된 숫자 등은 사용하지 마세요.</div>
                </div>
                <div className="center_box">
                    <div className="input_wrapper modify_pw_input_wrapper">
                        <div className="input_label">기존 비밀번호</div>
                        <input
                            type="password"
                            value={password.prev}
                            onChange={(e)=>{
                                setIsNonValidPW(false);
                                setPassword({...password, prev: e.target.value})
                            }}
                            style={{ borderColor: isNonValidPW ? '#DC3545' : "#707070" }}
                            placeholder="사용중인 비밀번호를 입력해주세요"
                        />
                        {isNonValidPW && <div className="validation">비밀번호가 일치하지 않습니다.</div>}
                    </div>
                    <div className="input_wrapper modify_pw_input_wrapper">
                        <div className="input_label">새로운 비밀번호</div>
                        <div className="input_item_wrapper">
                            <input
                                className={`input_with_icon ${validatePW(password.new, password.prev)==="valid" && "valid_input"}  ${validatePW(password.new, password.prev)==="non-valid" && "non_valid_input"}`}
                                type="password"
                                value={password.new}
                                onChange={(e)=>{
                                    setPassword({...password, new: e.target.value})
                                }}
                                placeholder="변경하실 비밀번호를 입력해주세요."
                            />
                            {validatePW(password.new, password.prev)==="valid" && <div className="valid_icon"><FaCheck /></div>}
                        </div>
                        {validatePW(password.new, password.prev)==="non-valid" && <div className="validation">올바른 비밀번호 형식이 아닙니다.</div>}
                        {validatePW(password.new, password.prev)==="valid" && <div className="validation success">올바른 비밀번호 형식입니다.</div>}                    
                    </div>
                    <div className="input_wrapper modify_pw_input_wrapper">
                        <div className="input_label">새로운 비밀번호 확인</div>
                        <div className="input_item_wrapper">
                            <input
                                className={`input_with_icon ${validateConfirmPW(password.new, password.confirm)==="valid" && "valid_input"}  ${validateConfirmPW(password.new, password.confirm)==="non-valid" && "non_valid_input"}`}
                                type="password"
                                value={password.confirm}
                                onChange={(e)=>{
                                    setPassword({...password, confirm: e.target.value})
                                }}
                                placeholder="변경하실 비밀번호를 재입력해주세요."
                            />
                            {validateConfirmPW(password.new, password.confirm)==="valid" && <div className="valid_icon"><FaCheck /></div>}
                        </div>
                        {validateConfirmPW(password.new, password.confirm)==="non-valid" && <div className="validation">비밀번호가 일치하지 않습니다.</div>}
                        {validateConfirmPW(password.new, password.confirm)==="valid" && <div className="validation success">비밀번호가 일치합니다.</div>}
                    </div>
                    <div className="button_wrapper">
                        <button className="submit" onClick={handleSubmit}>변경</button>
                        <button className="cancel" onClick={goToMyPageMain}>취소</button>
                    </div>
                </div>
                <CommonModal
                    header="비밀번호 변경"
                    body={ModifyModalBody}
                    footer={ModifyModalFooter}
                    show={showModifyModal}
                    setClose={closeModifyModal}
                    size="sm"
                />
            </div>
        </div>
    );
}

export default MomtheraMyPageModifyPW;